export default __webpack_public_path__ + "images/TRA.51ae4d6.png";